import { render, staticRenderFns } from "./league-data-crawler.vue?vue&type=template&id=7ce8c352&scoped=true"
import script from "./league-data-crawler.vue?vue&type=script&lang=js"
export * from "./league-data-crawler.vue?vue&type=script&lang=js"
import style0 from "./league-data-crawler.vue?vue&type=style&index=0&id=7ce8c352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce8c352",
  null
  
)

export default component.exports